// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const isMacOs = () => /Mac/i.test(window?.navigator?.platform);
export const getShortcutModifierKey = () => (isMacOs() ? 'meta' : 'ctrl');
